/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_ExpiryInputs */

const en_share_expiry = /** @type {(inputs: Share_ExpiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valid for`)
};

const de_share_expiry = /** @type {(inputs: Share_ExpiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gültig`)
};

/**
* | output |
* | --- |
* | "Valid for" |
*
* @param {Share_ExpiryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const share_expiry = /** @type {((inputs?: Share_ExpiryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_ExpiryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_share_expiry(inputs)
	return en_share_expiry(inputs)
});